import React, { useEffect, useState } from 'react';
import { MenuItem } from '@mui/material';
import Modal from '@mui/material/Modal';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Typography, TextField, Button, List, ListItem, ListItemText, IconButton, Box, Alert, Tooltip, Divider } from '@mui/material';
import SafeText from '../components/SafeText';
import api from '../axios';
import ModuleHeader from '../components/ModuleHeader';

function Matriculas() {
  const [openModal, setOpenModal] = useState(false);
  const [alunos, setAlunos] = useState([]);
  const [turmas, setTurmas] = useState([]);
  const [matriculas, setMatriculas] = useState([]);
  const [alunoId, setAlunoId] = useState('');
  const [turmaId, setTurmaId] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [editId, setEditId] = useState(null);
  const [editAlunoId, setEditAlunoId] = useState('');
  const [editTurmaId, setEditTurmaId] = useState('');

  const fetchMatriculas = async () => {
    const res = await api.get('/matriculas/');
    setMatriculas(res.data);
  };

  useEffect(() => {
    fetchMatriculas();
    // Buscar alunos
    api.get('/alunos/')
      .then(res => setAlunos(res.data));
    // Buscar turmas
    api.get('/turmas/')
      .then(res => setTurmas(res.data));
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    setErro(''); setSucesso('');
    if (!alunoId || !turmaId) {
      setErro('Preencha aluno e turma');
      return;
    }
    try {
      await api.post(`/matriculas/?aluno_id=${alunoId}&turma_id=${turmaId}`);
      setAlunoId(''); setTurmaId('');
      setSucesso('Matrícula realizada!');
      fetchMatriculas();
    } catch {
      setErro('Erro de conexão');
    }
  };

  const handleDelete = async (id) => {
    await api.delete(`/matriculas/${id}`);
    fetchMatriculas();
  };

  // Função para iniciar edição
  const handleEdit = (id) => {
    const matricula = matriculas.find(m => m.id === id);
    setEditId(id);
    setEditAlunoId(matricula.aluno_id);
    setEditTurmaId(matricula.turma_id);
    setErro('');
    setSucesso('');
  };

  // Função para salvar edição
  const handleSaveEdit = async (id) => {
    setErro(''); setSucesso('');
    if (!editAlunoId || !editTurmaId) {
      setErro('Preencha aluno e turma');
      return;
    }
    try {
      await api.put(`/matriculas/${id}`, {
        aluno_id: parseInt(editAlunoId),
        turma_id: parseInt(editTurmaId)
      });
      setSucesso('Matrícula atualizada!');
      setEditId(null);
      fetchMatriculas();
    } catch {
      setErro('Erro de conexão');
    }
  };

  // Função para cancelar edição
  const handleCancelEdit = () => {
    setEditId(null);
    setEditAlunoId('');
    setEditTurmaId('');
    setErro('');
    setSucesso('');
  };

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
      <ModuleHeader module="Start" title="Matrículas" />
      <Button variant="contained" color="primary" sx={{ mb: 2 }} onClick={() => setOpenModal(true)} startIcon={<AddIcon />}>
        Matricular
      </Button>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2, width: '80vw', maxWidth: 500 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">Nova Matrícula</Typography>
            <IconButton onClick={() => setOpenModal(false)}><CloseIcon /></IconButton>
          </Box>
          <Box component="form" onSubmit={(e) => { handleAdd(e); if (!erro) setOpenModal(false); }} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              select
              label="Aluno"
              value={alunoId}
              onChange={e => setAlunoId(e.target.value)}
              fullWidth
              size="small"
            >
              {alunos.map(aluno => (
                <MenuItem key={aluno.id} value={aluno.id}>{aluno.nome}</MenuItem>
              ))}
            </TextField>
            <TextField
              select
              label="Turma"
              value={turmaId}
              onChange={e => setTurmaId(e.target.value)}
              fullWidth
              size="small"
            >
              {turmas.map(turma => (
                <MenuItem key={turma.id} value={turma.id}>{turma.nome}</MenuItem>
              ))}
            </TextField>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Button type="submit" variant="contained" sx={{ flex: { xs: 1, sm: 'none' }, minWidth: 120, height: 40 }} startIcon={<SaveIcon />}>Matricular</Button>
              <Button variant="outlined" color="secondary" onClick={() => setOpenModal(false)} sx={{ flex: { xs: 1, sm: 'none' }, minWidth: 120, height: 40 }} startIcon={<CloseIcon />}>Cancelar</Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Button component={RouterLink} to="/" variant="outlined" color="primary" sx={{ mb: 2 }}>
        Voltar para a página inicial
      </Button>
      {erro && <Alert severity="error" sx={{ mb: 1 }}><SafeText value={erro} /></Alert>}
      {sucesso && <Alert severity="success" sx={{ mb: 1 }}><SafeText value={sucesso} /></Alert>}
      <List sx={{ bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
        {matriculas.map((matricula, idx) => (
          <React.Fragment key={matricula.id}>
            <ListItem divider sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {editId === matricula.id ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
                  <TextField
                    select
                    label="Aluno"
                    value={editAlunoId}
                    onChange={e => setEditAlunoId(e.target.value)}
                    size="small"
                    fullWidth
                  >
                    {alunos.map(aluno => (
                      <MenuItem key={aluno.id} value={aluno.id}>{aluno.nome}</MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    label="Turma"
                    value={editTurmaId}
                    onChange={e => setEditTurmaId(e.target.value)}
                    size="small"
                    fullWidth
                  >
                    {turmas.map(turma => (
                      <MenuItem key={turma.id} value={turma.id}>{turma.nome}</MenuItem>
                    ))}
                  </TextField>
                  <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                    <Button color="success" size="small" onClick={() => handleSaveEdit(matricula.id)} startIcon={<SaveIcon />}>Salvar</Button>
                    <Button color="inherit" size="small" onClick={handleCancelEdit} startIcon={<CloseIcon />}>Cancelar</Button>
                  </Box>
                </Box>
              ) : (
                <>
                  <ListItemText
                    primary={<SafeText value={`Aluno: ${alunos.find(a => a.id === matricula.aluno_id)?.nome || matricula.aluno_id} | Turma: ${turmas.find(t => t.id === matricula.turma_id)?.nome || matricula.turma_id}`} />}
                  />
                  <Box>
                    <Tooltip title="Editar">
                      <IconButton edge="end" onClick={() => handleEdit(matricula.id)} color="info">
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <IconButton edge="end" onClick={() => handleDelete(matricula.id)} color="error">
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </>
              )}
            </ListItem>
            {idx < matriculas.length - 1 && <Divider component="li" />}
          </React.Fragment>
        ))}
      </List>
    </Container>
  );
}

export default function MatriculasPageWrapper(props) {
  return <Matriculas {...props} />;
}
